import React, { Component } from "react";
import { Layout, Row, Col, Button, List, Space, Typography, Card, message, Popconfirm, PageHeader } from "antd";
import { FileSearchOutlined, EditOutlined, DeleteOutlined, FilterOutlined, PlusOutlined, MinusOutlined, SwapOutlined, StopOutlined, DownloadOutlined } from "@ant-design/icons";

import Logged from '../../../../Hooks/Logged';
import usePermissions from '../../../../Hooks/usePermissions';
import DrawerFiltros from '../../../Widgets/DrawerFiltros/DrawerFiltros';
import Sort from '../../../Widgets/Sort';
import CustomAvatar from '../../../Widgets/Avatar/Avatar';

import ModalTransaccion from '../../Finanzas/Transacciones/ModalTransaccion';
import ModalTransaccionDetalle from '../../Finanzas/Transacciones/ModalTransaccionDetalle';
import ActionsDropdown from "../../../Widgets/Actions/ActionsDropdown";

import axios from 'axios';
import moment from 'moment-timezone';

const { Content } = Layout;
const { Text } = Typography;

class TransaccionesProyectoTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            transacciones: {
                data: [],
                page: 1,
                limit: 20,
                total: 0,
                pages: 0,
                search: undefined,
                filters: [],
                sort: { fecha: -1 },
            },
            loading: false,

            modalTransacVisible: false,
            modalTransacDetalleVisible: false,
            transaccion_id: undefined,

            visibleFilters: false,
        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        this.getTransacciones()
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.search !== prevProps.search ||
            this.props.proyecto_id !== prevProps.proyecto_id
        ) {
            this.getTransacciones({ page: 1, search: this.props.search })
        }
    }

    getTransacciones = ({
        page = this.state.transacciones.page,
        limit = this.state.transacciones.limit,
        search = this.state.transacciones.search,
        filters = this.state.transacciones.filters,
        sort = this.state.transacciones.sort,
    } = this.state.transacciones) => {
            this.setState({
                transacciones: { ...this.state.transacciones, page, limit, search, filters, sort },
                loading: true
            })

            axios.post('/transacciones/filters', {
                page,
                limit,
                filters,
                sort,
                search,
                proyecto_id: this.props.proyecto_id,
            })
            .then(({ data }) => {
                const rows = data?.data ?? [];
                const total = data?.total ?? rows.length;
                const pages = data?.pages && data.pages > 0 ? data.pages : Math.ceil((total || 1) / (limit || 1));
                this.setState(s => ({
                    transacciones: {
                        ...s.transacciones,
                        data: rows,
                        total,
                        pages,
                        page,
                        limit,
                    },
                loading: false
                }))
            })
            .catch(() => message.error('No se pudieron cargar las transacciones'))
            .finally(() => this.setState({ loading: false }))
        }

    setSort = (key) => {
        let value
        switch (this.state.transacciones.sort?.[key]) {
            case 1: value = -1; break
            case -1: value = undefined; break
            default: value = 1; break
        }
        this.getTransacciones({ sort: { [key]: value } })
        this.setState(s => ({ transacciones: { ...s.transacciones, sort: { [key]: value } } }))
    }

    renderIconTransaccion = (tipo) => {
        switch (tipo) {
            case 1: return <PlusOutlined style={{ color: "currentColor" }} />
            case 2: return <MinusOutlined style={{ color: "currentColor" }} />
            case 3: return <SwapOutlined style={{ color: "currentColor" }} />
            case 4: return <StopOutlined style={{ color: "currentColor" }} />
            default: return null
        }
    }

    colorTipo = (tipo) => {
        switch (tipo) {
            case 1: return "#21a121"
            case 2: return "#d32029" 
            case 3: return "#8c8c8c" 
            case 4: return "#fa8c16" 
            default: return "currentColor"
        }
    }

    downloadCSV = async () => {
        const { transacciones } = this.state

        const {
            search,
            filters,
            sort,
        } = transacciones

        try {
            this.setState({ loading: true })

            const { data } = await axios.post(
                '/transacciones/filters',
                {
                    page: 1,
                    limit: 5000,
                    search,
                    filters,
                    sort,
                    proyecto_id: this.props.proyecto_id,
                    file: 'csv',
                },
                {
                    responseType: 'blob',
                }
            )

            const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')

            const nombreProyecto = (this.props.proyecto_info?.nombre || 'proyecto')
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '_')

            const fecha = moment().format('YYYY-MM-DD')

            link.href = url
            link.setAttribute('download', `transacciones_${nombreProyecto}_${fecha}.csv`)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        } catch (error) {
            console.error(error)
            message.error('No se pudo descargar el CSV de transacciones')
        } finally {
            this.setState({ loading: false })
        }
    }




    render() {
        const { transacciones, loading } = this.state;
        const pageLimit = (transacciones.page * transacciones.limit) - transacciones.limit;

        return (
            <>
                <PageHeader
                    className='custom-page-header custom-transacciones-header-cliente'
                    style={{ backgroundColor: "transparent" }}
                    title={null}
                    extra={
                        <Space>
                            <Text style={{ color: "black"}}>
                                Visualizando de {(pageLimit > 0) ? pageLimit : 1} a {(transacciones.page * transacciones.limit)} de {transacciones.total?.toLocaleString()} transacciones
                            </Text>

                            <Button onClick={this.downloadCSV} icon={<DownloadOutlined />} > CSV </Button>

                            <Button
                                type="dashed"
                                onClick={() => this.setState({ visibleFilters: true })}
                                className="button-plus"
                                icon={<FilterOutlined />}
                            />
                        </Space>
                    }
                />

                <Content className="admin-content content-bg pd-1">
                    <List
                        loading={loading}
                        className="component-list"
                        itemLayout="horizontal"
                        locale={{ emptyText: "Sin Transacciones" }}
                        dataSource={transacciones?.data}
                        pagination={{
                            current: transacciones.page,
                            pageSize: transacciones.limit,
                            total: transacciones.total,
                            position: 'bottom',
                            className: "flex-left",
                            showSizeChanger: true,
                            pageSizeOptions: [20, 50, 100, 500],
                            showQuickJumper: true,
                            locale: { jump_to: "Ir a la página", page: '' },
                            onChange: (page, limit) => this.getTransacciones({ page, limit })
                        }}
                        header={
                            <Row className="header-list width-100">

                                <Col xs={3} className="center">
                                    <Sort sort={transacciones?.sort?.["fecha"]} onClick={() => this.setSort("fecha")}>
                                        <Text strong>FECHA</Text>
                                    </Sort>
                                </Col>

                                <Col xs={4} className="center">
                                    <Sort sort={transacciones?.sort?.["concepto"]} onClick={() => this.setSort("concepto")}>
                                        <Text strong>CONCEPTO</Text>
                                    </Sort>
                                </Col>

                                <Col xs={4} className="center">
                                    <Sort sort={transacciones?.sort?.["area_id.nombre"]} onClick={() => this.setSort("area_id.nombre")}>
                                        <Text strong>ÁREA</Text>
                                    </Sort>
                                </Col>

                                <Col xs={4} className="center">
                                    <Sort sort={transacciones?.sort?.["rubro_id.nombre"]} onClick={() => this.setSort("rubro_id.nombre")}>
                                        <Text strong>RUBRO</Text>
                                    </Sort>
                                </Col>

                                <Col xs={4} className="center">
                                    <Sort sort={transacciones?.sort?.["cuenta_id.nombre"]} onClick={() => this.setSort("cuenta_id.nombre")}>
                                        <Text strong>CUENTA</Text>
                                    </Sort>
                                </Col>

                                <Col xs={3} className="center">
                                    <Sort sort={transacciones?.sort?.["monto"]} onClick={() => this.setSort("monto")}>
                                        <Text strong>MONTO</Text>
                                    </Sort>
                                </Col>

                                <Col xs={2} className="center" />
                            </Row>
                        }

                        renderItem={(item) => (
                            <List.Item className="component-list-item ">
                                <Card className="card-list" bordered={false}>
                                    <div className={`badge-card tipo-${item.tipo}`} />
                                    <Row className="width-100" align="middle">
                                        <Col xs={3} className="center">
                                            <Text strong>{moment.tz(item.fecha, "America/Mexico_City").format('YYYY-MM-DD')}</Text>
                                        </Col>

                                        <Col xs={4} className="flex-column">
                                            <Text ellipsis className="text-gray-dark">{item.concepto}</Text>
                                            <Text ellipsis style={{ fontSize: 12 }}>{item.uuid ? item.uuid : null}</Text>
                                        </Col>

                                        <Col xs={4} className="center">
                                            <Text ellipsis className="text-gray-dark">{item.area_id?.nombre}</Text>
                                        </Col>

                                        <Col xs={4} className="center">
                                            <Text ellipsis className="text-gray-dark">{item.rubro_id?.nombre}</Text>
                                        </Col>

                                        <Col xs={4} className="center">
                                            {item?.cuenta_id && (
                                                <>
                                                    <CustomAvatar
                                                        image={axios.defaults.baseURL + '/upload/' + item?.cuenta_id?.logo}
                                                        color={item.cuenta_id?.color}
                                                        name={item.cuenta_id?.nombre}
                                                    />
                                                    <Text className="text-gray-dark">{item.cuenta_id?.nombre}</Text>
                                                </>
                                            )}
                                        </Col>

                                        <Col xs={3} className="center">
                                            <Text style={{ color: this.colorTipo(item.tipo), fontWeight: "bold" }}>
                                                {this.renderIconTransaccion(item.tipo)} $ {item.monto.toMoney(true)} MXN
                                            </Text>
                                        </Col>

                                        <Col xs={2} className="center">
                                            <ActionsDropdown
                                                onView={() =>
                                                    this.setState({
                                                        modalTransacDetalleVisible: true,
                                                        transaccion_id: item._id,
                                                    })
                                                }
                                                onEdit={() =>
                                                    this.setState({
                                                        modalTransacVisible: true,
                                                        transaccion_id: item._id,
                                                    })
                                                }
                                                onDelete={() =>
                                                axios
                                                    .delete('/transacciones', { params: { id: item._id } })
                                                    .then(() => {
                                                        message.success('Transacción Eliminada');
                                                        this.getTransacciones();
                                                    })
                                                    .catch(() => {
                                                        message.error('Transacción No Eliminada');
                                                        this.getTransacciones();
                                                    })
                                                }
                                                
                                            />
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Content>

                <ModalTransaccion
                    visible={this.state.modalTransacVisible}
                    transaccion_id={this.state.transaccion_id}
                    onClose={() => {
                        this.setState({ modalTransacVisible: false, transaccion_id: undefined })
                        this.getTransacciones()
                    }}
                    
                    disabled={{ proyecto: true }}
                    required={{ proyecto: true }}
                    initialValues={{
                        proyecto_id: this.props.proyecto_info
                        ? { value: this.props.proyecto_info._id, label: this.props.proyecto_info.nombre }
                        : (this.props.proyecto_id ? { value: this.props.proyecto_id, label: 'Proyecto' } : null),
                    }}
                />
                <ModalTransaccionDetalle
                    visible={this.state.modalTransacDetalleVisible}
                    onClose={() => this.setState({ modalTransacDetalleVisible: false, transaccion_id: null })}
                    transaccion_id={this.state.transaccion_id}
                />

                <DrawerFiltros
                    title="Filtrar Transacciones"
                    ref={ref => this.drawerFiltros = ref}
                    updateFilters={filters => this.getTransacciones({ page: 1, filters })}
                    onClose={() => this.setState({ visibleFilters: false })}
                    visible={this.state.visibleFilters}
                    proveedores={true}
                    accreedores={true}
                    acreedores={true}
                    inversiones={true}
                    ordenes={false}
                    ordenes_compras={false}
                />
            </>
        )
    }
}

export default function (props) {
    const user = React.useContext(Logged)

    const permissions = usePermissions(user?.rol_id?.permisos, {
        editTransacciones: ["transacciones", "edit"],
        deleteTransacciones: ["transacciones", "delete"],
        readTransacciones: ["transacciones", "read"],
    })

    return (
        <TransaccionesProyectoTab
            {...props}
            {...permissions}
        />
    );
}
